(function () {
    'use strict';

    const global = tinymce.util.Tools.resolve('tinymce.PluginManager');

    const optionName = 'autosavecursor_show_cursor_marker';

    const setCursorLocationToMarker = function (e) {
        const editor = e.target;
        const cursorMarker = editor.dom.select('#cursorMarker');
        if (cursorMarker.length) {
            editor.selection.select(cursorMarker[0]);
            editor.selection.collapse(0);
            editor.focus();
            editor.dom.replace(
                editor.dom.create('br', {'data-mce-bogus': '1'}),
                cursorMarker
            );

            if (editor.options.get(optionName)) {
                addCursorMarkerAtCurrentPos(editor);
            }
        }
    };

    const addCursorMarkerAtCurrentPos = function (editor) {
        // unwrap the bookmark - https://plainjs.com/javascript/manipulation/unwrap-a-dom-element-35/
        let el, parent
        const elms = editor.dom.select('span[data-mce-type=bookmark]'), elmsLength = elms.length;
        for (var i = 0; i < elmsLength; i++) {
            el = elms[i];

            parent = el.parentNode;
            while (el.firstChild) parent.insertBefore(el.firstChild, el);
            parent.removeChild(el);
        }

        editor.selection.getBookmark();

        editor.dom.select('span[data-mce-type=bookmark]').forEach(function (elm) {
            elm.setAttribute('title', Lang.get('core.cursor_position'));
        });
    };

    function addToToolbar(editor) {
        editor.ui.registry.addButton('autosavecursor', {
            icon: 'bookmark',
            title: Lang.get('core.set_cursor_position'),
            tooltip: Lang.get('core.set_cursor_position'),
            onAction: function () {
                addCursorMarkerAtCurrentPos(editor)
            }
        })
    }

    function registerOptions(editor) {
        const registerOption = editor.options.register;
        registerOption(optionName, {processor: "boolean", default: false});
    }

    function init (editor) {
        registerOptions(editor);
        addToToolbar(editor);

        editor.on('init', function () {
            editor.serializer.addNodeFilter('span', function (nodes, name, args) {
                if (args.withoutCursorMarker) {
                    return;
                }

                let i = nodes.length,
                    cursorMarker = new tinymce.html.Node('span', 1),
                    cursorMarkerTextElm = tinymce.html.Node.create('#text');

                cursorMarkerTextElm.value = "\ufeff";
                cursorMarker.attr('id', 'cursorMarker');
                cursorMarker.append(cursorMarkerTextElm);

                while (i--) {
                    const node = nodes[i];
                    if (node.attr('data-mce-type') === 'bookmark') {
                        node.parent.insert(cursorMarker, node);

                        break;
                    }
                }
            });
        });

        editor.on('SetContent', setCursorLocationToMarker);
    }

    function Plugin () {
        global.add('autosavecursor', function (editor) {
            init(editor);

            return {};
        });
    }

    Plugin();

}());
